import './PleaseWait.scss'

const PleaseWait = () => (
    <div className="please-wait">
        <h3>Please wait..</h3>
    </div>
)

export default PleaseWait
